<template>
  <div class="relative !h-[75vh] grid place-items-center">
    <div class="unauthorized"></div>
    <div class="restricted">
      <h5 class="font-bold text-black text-2xl">Access Restricted</h5>
      <p class="pt-2">You don’t have permission to view this section.</p>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.unauthorized {
  @apply h-full w-full blur-lg !absolute !inset-0;
  background: rgba(249, 250, 252, 1) !important;
}

.restricted {
  @apply w-[380px] h-[112px] rounded-3xl flex flex-col items-center justify-center relative;
  box-shadow: 0px 20px 48px 0px rgba(170, 170, 170, 0.29);
  background: rgba(243, 246, 245, 0.54);
  backdrop-filter: blur(36px);
  z-index: 10;
}
</style>